import { Subject } from "rxjs";

const ReceiveMessageServiceSubject = new Subject();
const SendMessageServiceSubject = new Subject();

export const ReceiveMessageService = {
  listen: () => ReceiveMessageServiceSubject.asObservable(),
  receive: (message) => {
    ReceiveMessageServiceSubject.next(message);
  },
};
export const SendMessageService = {
  listen: () => SendMessageServiceSubject.asObservable(),
  receive: (message) => {
    SendMessageServiceSubject.next(message);
  },
};


